// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"64":"e4ba96f9","513":"7997c121","805":"10e0d2c0"}[chunkId] + ".js";
};